import {Option} from "ts-option";
import Address from "../address/Address";
import LatLng from "../map/LatLng";
import Phone from "../phone/Phone";

/**
 * User data model.
 */
export default class UserData {
	/**
	 * @param username username of user.
	 * @param firstName first name.
	 * @param lastName last name.
	 * @param roles User roles. Possible values 'ADMIN', 'AGENT', THIRD_PARTY_INSTALLER_ENGINEER, SALES_ENGINEER, BUSINESS_DEVELOPMENT_PARTNER
	 * @param permissions User permissions.
	 * @param organisationName organisation name where users belongs.
	 * @param homeAddress User home address
	 * @param mobileNumber user mobile phone number.
	 * @param profileUrl user profile url.
	 * @param brandId user brand identifier
	 * @param homeAddressLocation home address GPS location.
	 * @param postCodes Postcodes of locations supported by 3rd party engineer
	 * @param bioText User bio.
	 * @param photoId User image.
	 * @param partnerBrandId
	 * @param licenceNumber User Gas Safe licence card number.
	 */
	constructor(public readonly username: string,
		public readonly firstName: string,
		public readonly lastName: string,
		public readonly roles: string[],
		public readonly permissions: string[],
		public readonly organisationName: string,
		public readonly homeAddress: Option<Address>,
		public readonly mobileNumber: Option<Phone>,
		public readonly profileUrl: Option<string>,
		public readonly brandId: Option<string>,
		public readonly homeAddressLocation: Option<LatLng>,
		public readonly bioText: Option<string>,
		public readonly photoId: Option<string>,
		public readonly partnerBrandId: Option<string>,
		public readonly licenceNumber: Option<string>) {}

	/**
	 * Check if user have admin rights.
	 */
	isAdmin(): boolean {
		return this.roles.indexOf("ADMIN") > -1;
	}

	copy({
		username = this.username,
		firstName = this.firstName,
		lastName = this.lastName,
		roles = this.roles,
		permissions = this.permissions,
		organizationName = this.organisationName,
		homeAddress = this.homeAddress,
		mobileNumber = this.mobileNumber,
		profileUrl = this.profileUrl,
		homeAddressLocation = this.homeAddressLocation,
		brandId = this.brandId,
		bioText = this.bioText,
		photoId = this.photoId,
		partnerBrandId = this.partnerBrandId,
		licenceNumber = this.licenceNumber,
	}) {
		return new UserData(username, firstName, lastName, roles, permissions, organizationName, homeAddress, mobileNumber,
			profileUrl, brandId, homeAddressLocation, bioText, photoId, partnerBrandId, licenceNumber)
	}
}